import _Date$now from "@babel/runtime-corejs3/core-js-stable/date/now";
import _setTimeout from "@babel/runtime-corejs3/core-js-stable/set-timeout";
export default function (fn, ms) {
  if (!ms) {
    return fn;
  }

  var last = 0;
  var timeout = null;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var now = _Date$now();

    if (now - last > ms) {
      fn.apply(void 0, args);
      last = now;
    } else {
      clearTimeout(timeout);
      timeout = _setTimeout(function () {
        fn.apply(void 0, args);
        last = _Date$now();
      }, Math.max(0, ms - now + last));
    }
  };
}